import { useFormContext } from 'react-hook-form'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardFooter } from '@/components/ui/card'
import { FormField } from '@/components/ui/form'
import { FormFieldset } from '@/components/ui/form-field/fieldset'
import { FileUploader } from '@/components/ui/form-field/file-uploader'
import { Input } from '@/components/ui/input'

import { CompanyFormDto } from './dto'

export function CompanyForm() {
  const { control } = useFormContext<CompanyFormDto>()

  return (
    <Card className="max-w-full overflow-auto">
      <CardContent className="relative grid grid-cols-2 gap-x-2 gap-y-4 overflow-x-auto p-4">
        <FormField
          control={control}
          name="name"
          render={({ field }) => (
            <FormFieldset label="Nama Perusahaan" className="col-span-full">
              <Input placeholder="Masukkan nama perusahaan" {...field} />
            </FormFieldset>
          )}
        />

        <div className="col-span-full mt-2">
          <h2 className="font-medium">Total Penerimaan</h2>
        </div>
        <FormField
          control={control}
          name="size_from"
          render={({ field }) => (
            <FormFieldset label="Start" className="">
              <Input placeholder="Start" type="number" {...field} />
            </FormFieldset>
          )}
        />
        <FormField
          control={control}
          name="size_to"
          render={({ field }) => (
            <FormFieldset label="End" className="">
              <Input placeholder="End" {...field} type="number" />
            </FormFieldset>
          )}
        />

        <CompanyLogo />
      </CardContent>
      <CardFooter className="pt-4">
        <Button size="sm" className="ml-auto" type="submit">
          Simpan Perubahan
        </Button>
      </CardFooter>
    </Card>
  )
}

function CompanyLogo() {
  const { control } = useFormContext<CompanyFormDto>()

  return (
    <FormField
      control={control}
      name="logo"
      render={({ field }) => (
        <FormFieldset label="Logo Perusahaan" className="col-span-full">
          <FileUploader
            value={field.value ? [field.value] : []}
            onValueChange={(files) => {
              field.onChange(files?.[0] || null)
            }}
          />
        </FormFieldset>
      )}
    />
  )
}
